// Array with all the names of the svgs that will be used with mat-icon.
export const APP_ICONS = [
  'android',
  'arrow_down',
  'bug',
  'burger_menu',
  'cloud_extension_v3_grey',
  'dictionary',
  'educational_material',
  'epub_grey_1',
  'feedback_lvl_1',
  'feedback_lvl_2',
  'feedback_lvl_5',
  'feedback_lvl_6',
  'feedback_lvl_7',
  'feedback',
  'file',
  'flags/da-DK',
  'flags/en-GB',
  'flags/fo-FO',
  'flags/nb-NO',
  'flags/nl-NL',
  'flags/nn-NO',
  'flags/sv-SE',
  'grammar',
  'globe',
  'info',
  'intowords_logo',
  'ios',
  'language',
  'mac',
  'ocr1',
  'other',
  'pdf_grey_1',
  'play',
  'profile_settings',
  'sales',
  'send',
  'suggestions',
  'templates',
  'terms_new',
  'text_color',
  'translation_20',
  'wish',
  'windows',
];

// Default feedback types.
export const FEEDBACK_TYPES = [
  { type: 'feedback', icon: 'feedback' },
  { type: 'bug', icon: 'bug' },
  { type: 'wish', icon: 'wish' },
  { type: 'sales', icon: 'sales' },
];

// Default satisfaction levels.
export const SATISFACTION_LEVELS = [
  { type: '1', icon: 'feedback_lvl_1' },
  { type: '2', icon: 'feedback_lvl_2' },
  { type: '3', icon: 'feedback_lvl_5' },
  { type: '4', icon: 'feedback_lvl_6' },
  { type: '5', icon: 'feedback_lvl_7' },
];

// Default features.
export const FEATURES = [
  { type: 'settings', icon: 'profile_settings' },
  { type: 'play', icon: 'play' },
  { type: 'suggestions', icon: 'suggestions' },
  { type: 'terms', icon: 'terms_new' },
  { type: 'translate', icon: 'translation_20' },
  { type: 'file', icon: 'file' },
  { type: 'ocr', icon: 'ocr1' },
  { type: 'grammar', icon: 'grammar' },
  { type: 'templates', icon: 'templates' },
  { type: 'dictionary', icon: 'dictionary' },
  { type: 'text', icon: 'text_color' },
  { type: 'pdf', icon: 'pdf_grey_1' },
  { type: 'epub', icon: 'epub_grey_1' },
  { type: 'other', icon: 'other' },
];

// Default platforms.
export const PLATFORMS = [
  { type: 'IntoWords Windows', icon: 'windows' },
  { type: 'IntoWords Mac', icon: 'mac' },
  { type: 'IntoWords Cloud', icon: 'cloud_extension_v3_grey' },
  { type: 'IntoWords iOS', icon: 'ios' },
  { type: 'IntoWords Android', icon: 'android' },
  { type: 'IntoWords Cloudapp', icon: 'globe' },
];

// Storage keys enum.
// STATUS_LANGUAGE is the name for the current language.
export enum STORAGE_KEY_TYPE {
  STATUS_LANGUAGE = 'statusLanguage',
}

// Default debounce time.
export const DEFAULT_DEBOUNCE_MIN_TIME = 300;

// Default months.
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
